define('services/consoleApi/project.manage.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('projectManageService', ['$q', '$state', 'OpenApp', 'auiDialog', 'ngDialog', 'auiAgreementHelper', 'reportUtil', 'OpenOther', function ($q, $state, OpenApp, auiDialog, ngDialog, auiAgreementHelper, reportUtil, OpenOther) {

        var lang = 'zh_CN';
        var projectKey = '0';
        var kitsCache;
        var kitsList;
        var projectTotalCount;
        var apiIDToNameFilter = {};

        //获取列表  处理缓存
        function getProjectList(paramReq) {
            var defer = $q.defer();
            var param = {};
            if (paramReq && paramReq.searchTxt != '') {
                param.searchName = paramReq.searchTxt;
            }
            if (paramReq && paramReq.fromRecCount) {
                param.fromRecCount = paramReq.fromRecCount;
            }
            if (paramReq && paramReq.maxReqCount) {
                param.maxReqCount = paramReq.maxReqCount;
            }
            param.sortType = 1;
            var searchParams = {
                req: param
            };
            OpenApp.getProjectList(searchParams).then(function (resp) {
                if (resp && resp.resultCode == 0) {
                    projectTotalCount = 10000 - resp.leftProjectQuota;
                }
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function getProjectTotalCount() {
            var defer = $q.defer();
            getProjectList().then(function () {
                defer.resolve(projectTotalCount);
                return defer.promise;
            });
            return defer.promise;
        }

        //获取详情
        function getProjectInfo(paramReq) {
            var defer = $q.defer();
            var searchParams = {
                req: paramReq
            };
            OpenApp.getProjectInfo(searchParams).then(function (resp) {
                if (resp && resp.projectInfo && resp.projectInfo != null) {
                    defer.resolve(resp);
                } else {
                    setProjectKey('0');
                    $state.go('myApi', {projectKey: '0'}, {reload: true});
                    defer.reject();
                }
            }).catch(function (resp) {
                setProjectKey('0');
                $state.go('myApi', {projectKey: '0'}, {reload: true});
                defer.reject(resp);
            });
            return defer.promise;
        }

        //创建Project
        function createProject() {
            var defer = $q.defer();
            var handle = ngDialog.open({
                template: 'pages/consoleApi/template/project.create.html',
                className: '',
                controller: ['$scope', function ($scope) {
                    getProjectTotalCount().then(function (count) {
                        $scope.leftProjectQuota = 10000 - count;
                    });
                    $scope.proDetail = function () {
                        var deferTemp = $q.defer();
                        addProject($scope.projectName, $scope.projectKey, $scope.projectDesc).then(function (resp) {
                            if (resp && resp.resultCode == 0) {
                                resp.projectKey = $scope.projectKey;
                                deferTemp.resolve();
                                defer.resolve(resp);
                                handle.close();
                            }
                        }).catch(function (resp) {
                            deferTemp.reject();
                        });
                        return deferTemp.promise;
                    };
                    $scope.cancel = function () {
                        handle.close();
                    }
                }]
            });
            return defer.promise;
        }


        function addProject(projectName, projectKey, projectDesc) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectName: projectName,
                    projectKey: projectKey,
                    originService: 1
                }
            }
            OpenApp.addProject(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }


        function getProjectAPI(projectID) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID,
                    language: lang
                }
            };
            OpenApp.getProjectAPI(params).then(function (resp) {
                if (resp && resp.projectAPIInfoList) {
                    //用户已有的api列表
                    resp.apiIDList = [];
                    resp.apiInfoList = angular.copy(resp.projectAPIInfoList);
                    getKitList().then(function (kitdata) {
                        resp.apiInfoList.forEach(function (apiInfo) {
                            kitdata.kitInfoList.forEach(function (kitInfo) {
                                if (kitInfo.kitID == apiInfo.kitID && apiInfo.langInfoDTOMap && kitInfo.langInfo) {
                                    apiInfo.kitName = kitInfo.langInfo.kitName;
                                    resp.apiIDList.push(apiInfo.apiID);
                                    apiInfo.langInfo = apiInfo.langInfoDTOMap[lang];
                                    defer.resolve(resp);
                                }
                            });
                        });
                    });
                } else {
                    resp.apiIDList = [];
                    defer.resolve(resp);
                }
            }).catch(function (resp) {

                resp.apiIDList = [];
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function getAllApiList() {
            var defer = $q.defer();
            if (kitsCache && kitsCache.kitInfoList && kitsCache.kitInfoList.length > 0) {
                defer.resolve(kitsCache);
                return defer.promise;
            } else {
                getKitList().then(function (kitdata) {
                    var kits = {};
                    var kitsApiList = [];
                    kits.kitInfoList = kitdata.kitInfoList;
                    getAvailableAPIList().then(function (apidata) {
                        var apiInfoList = apidata.apiInfoList;
                        kits.kitInfoList.forEach(function (kitInfo) {
                            kitInfo.apilist = [];
                            apiInfoList.forEach(function (apiInfo) {
                                if (apiInfo.kitID == kitInfo.kitID && kitInfo.langInfoDTOMap && kitInfo.langInfoDTOMap[lang] && apiInfo.langInfoDTOMap && apiInfo.langInfoDTOMap[lang]) {
                                    apiInfo.kitName = kitInfo.langInfoDTOMap[lang].kitName;
                                    apiInfo.langInfo = apiInfo.langInfoDTOMap[lang];
                                    kitsApiList.push(apiInfo);
                                }
                            })
                        });
                        defer.resolve(kitsApiList);
                    });
                });
            }
            return defer.promise;
        }

        function getAllKitList() {
            var defer = $q.defer();
            if (kitsCache && kitsCache.kitInfoList && kitsCache.kitInfoList.length > 0) {
                defer.resolve(kitsCache);
                return defer.promise;
            } else {
                getKitList().then(function (kitdata) {
                    var kits = {};
                    kits.kitInfoList = kitdata.kitInfoList;
                    getAvailableAPIList().then(function (apidata) {
                        var apiInfoList = apidata.apiInfoList;
                        var apiConsoleSetting = angular.copy(sysParamCfg.apiConsoleSetting);
                        kits.kitInfoList.forEach(function (kitInfo) {
                            kitInfo.apilist = [];
                            kitInfo.showTree = false;

                            apiInfoList.forEach(function (apiInfo) {
                                if (apiInfo.kitID == kitInfo.kitID && kitInfo.langInfoDTOMap && kitInfo.langInfoDTOMap[lang] && apiInfo.langInfoDTOMap && apiInfo.langInfoDTOMap[lang]) {
                                    apiInfo.kitName = kitInfo.langInfoDTOMap[lang].kitName;
                                    apiInfo.langInfo = apiInfo.langInfoDTOMap[lang];
                                    //API上加上名称
                                    if (apiConsoleSetting.kitIDToCate[kitInfo.kitID]) {
                                        apiInfo.cateName = apiConsoleSetting.kitIDToCate[kitInfo.kitID];
                                    } else {
                                        //找不到的都放到其他上去
                                        apiInfo.cateName = '其他';
                                    }
                                    kitInfo.apilist.push(apiInfo);
                                }
                            })
                        });
                        defer.resolve(kits.kitInfoList);
                    });
                });
            }
            return defer.promise;
        }

        function getAllApiTileList(apiID) {
            var defer = $q.defer();
            var apiInfoList = [];
            getAllApiList().then(function (apikitInfoList) {
                apikitInfoList.forEach(function (api) {
                    if (api.apiID != apiID) {
                        apiInfoList.push(api);
                    }
                });
                defer.resolve(apiInfoList);
            });

            return defer.promise;
        }

        function getApiIDToNameFilter() {
            var defer = $q.defer();

            if (angular.equals({}, apiIDToNameFilter)) {
                var params = {
                    req: {}
                };
                OpenApp.getAPIList(params).then(function (resp) {
                    apiIDToNameFilter.apiIDToIsAuditFilter = {};
                    var apiList = resp.apiInfoList;
                    apiList.forEach(function (apiInfo) {
                        if (apiInfo.langInfoDTOMap && apiInfo.langInfoDTOMap[lang]) {
                            apiIDToNameFilter[apiInfo.apiID] = apiInfo.langInfoDTOMap[lang].apiName;
                            apiIDToNameFilter.apiIDToIsAuditFilter[apiInfo.apiID] = apiInfo.isAudit;
                        }
                    });
                    defer.resolve(apiIDToNameFilter);
                }).catch(function (resp) {
                    defer.reject(resp);
                });
            } else {
                defer.resolve(apiIDToNameFilter);
            }
            return defer.promise;
        }

        function getKitList() {
            var defer = $q.defer();
            if (kitsList && kitsList.kitInfoList && kitsList.kitInfoList.length > 0) {
                defer.resolve(kitsList);
            } else {
                var params = {
                    req: {language: lang}
                };
                OpenApp.getKitList(params).then(function (resp) {
                    resp.kitInfoList.forEach(function (kitInfo) {
                        if (kitInfo.langInfoDTOMap && kitInfo.langInfoDTOMap[lang]) {
                            kitInfo.langInfo = kitInfo.langInfoDTOMap[lang];
                        }
                    });
                    kitsList = angular.copy(resp);
                    defer.resolve(resp);
                }).catch(function (resp) {
                    defer.reject(resp);
                });
            }
            return defer.promise;
        }

        function getSearchApiList(list) {
            var defer = $q.defer();
            getKitList().then(function (resp) {
                var kits = {};
                var kitsApiList = [];
                kits.kitInfoList = resp.kitInfoList;
                kits.kitInfoList.forEach(function (kitInfo) {
                    kitInfo.apilist = [];
                    list.forEach(function (apiInfo) {
                        if (apiInfo.kitID == kitInfo.kitID && kitInfo.langInfoDTOMap && kitInfo.langInfoDTOMap[lang] && apiInfo.langInfoDTOMap && apiInfo.langInfoDTOMap[lang]) {
                            apiInfo.kitName = kitInfo.langInfoDTOMap[lang].kitName;
                            apiInfo.langInfo = apiInfo.langInfoDTOMap[lang];
                            kitInfo.apilist.push(apiInfo);
                        }
                    })
                });
                kits.kitInfoList.forEach(function (item) {
                    if (item.apilist.length > 0) {
                        kitsApiList.push(item)
                    }
                });
                defer.resolve(kitsApiList);
            });
            return defer.promise;
        }

        function getAvailableAPIList(kitID) {
            var defer = $q.defer();
            var params = {req: {language: lang}};
            OpenApp.getAvailableAPIList(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function delProjectAPI(projectID, apiList) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID,
                    apiList: apiList,
                    originService: 1
                }
            };
            OpenApp.delProjectAPI(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function addProjectAPI(projectID, apiList) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID,
                    apiList: apiList,
                    originService: 1
                }
            };
            OpenApp.addProjectAPI(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function setProjectKey(proKey) {
            projectKey = proKey;
        }

        function getProjectKey() {
            return projectKey;
        }


        function addSubAccount(param) {
            var defer = $q.defer();
            var params = {
                req: param
            };
            OpenApp.addSubAccount(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function getProjectCredentialList(projectID, credentailType) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID
                }
            };
            if (credentailType) {
                params.req.credentailType = credentailType
            }
            OpenApp.getProjectCredentialList(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function addApiKey(projectID, apiKeyName) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID,
                    apiKeyName: apiKeyName,
                    flag: 0
                }
            };
            OpenApp.addApiKey(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function delClient(clientID, type) {
            var defer = $q.defer();
            var params = {
                req: {
                    clientID: clientID,
                    clientType: type
                }
            };
            OpenApp.delClient(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function modApiKey(req) {
            var defer = $q.defer();
            var params = {
                req: req
            }
            OpenApp.modApiKey(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function addSAKey(projectID, clientID, publicKey) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID,
                    clientID: clientID,
                    publicKey: publicKey
                }
            }
            OpenApp.addSAKey(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function delSAK(publicKeyID) {
            var defer = $q.defer();
            var params = {
                req: {
                    publicKeyID: publicKeyID
                }
            }
            OpenApp.delSAKey(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function modSubAccountStatus(clientID, status) {
            var defer = $q.defer();
            var params = {
                req: {
                    clientID: clientID,
                    status: status
                }
            }
            OpenApp.modSubAccountStatus(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function getAPIDetail(apiID) {
            var defer = $q.defer();
            var params = {
                req: {
                    apiID: apiID,
                    language: lang
                }
            };
            OpenApp.getAPIDetail(params).then(function (resp) {
                if (resp && resp.apiDetail) {
                    resp.apiDetail.langInfo = resp.apiDetail.langInfoDTOMap[lang];
                    getKitList().then(function (respkit) {
                        respkit.kitInfoList.forEach(function (kitInfo) {
                            if (kitInfo.kitID == resp.apiDetail.kitID && kitInfo.langInfo) {
                                resp.apiDetail.kitName = kitInfo.langInfo.kitName;
                                defer.resolve(resp);
                            }
                        })
                    })
                }
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function getApiListByIds(apiIDs) {
            var defer = $q.defer();
            var kitsApiListIDs = [];
            getAllApiList().then(function (kitsApiList) {
                kitsApiList.forEach(function (kitsApi) {
                    if (AUI.BaseJSUtil.contains(apiIDs, kitsApi.apiID)) {
                        kitsApiListIDs.push(kitsApi);
                        defer.resolve(kitsApiListIDs);
                    }
                })
            })
            return defer.promise;

        }

        function addOauth(req) {
            var defer = $q.defer();
            var reqv2 = {};
            reqv2.prodType = req.appAbs.prodType;
            reqv2.projectID = req.appAbs.projectID;
            reqv2.credentialType = req.credentialType;
            reqv2.defaultLang = req.appAbs.defaultLang;
            reqv2.oauthClientAttr = {
                appAttrs: req.appAttrs,
                clientName: req.appAbs.prodName
            };
            req.appAbs.webAppUrl && (reqv2.oauthClientAttr.webAppUrl = req.appAbs.webAppUrl);
            req.appAbs.packageName && (reqv2.oauthClientAttr.packageName = req.appAbs.packageName);
            reqv2.clientLangList = [{language: req.appAbs.defaultLang, clientName: req.appAbs.prodName}];
            var paramsv2 = {
                req: reqv2
            }
            OpenApp.addOauthClientV2(paramsv2).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });

            return defer.promise;
        }


        function updateOauth(req) {
            var defer = $q.defer();
            var reqModv2 = {};
            reqModv2.oauthClientAttr = {
                appAttrs: req.appAttrs
            };
            reqModv2.clientID = req.appAbs.prodID;
            (req.appAbs.webAppUrl || req.appAbs.webAppUrl == '') && (reqModv2.oauthClientAttr.webAppUrl = req.appAbs.webAppUrl);
            req.appAbs.packageName && (reqModv2.oauthClientAttr.packageName = req.appAbs.packageName);
            var paramsv2 = {
                req: reqModv2
            }
            OpenApp.modOauthClientV2(paramsv2).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });

            return defer.promise;
        }

        //判断是否签署过订购协议
        function getIsSignAgreement(agreementTypes) {
            var defer = $q.defer();
            auiAgreementHelper.queryAgreements(agreementTypes).then(function (signInfo) {
                if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                    defer.resolve(signInfo);
                } else {
                    auiDialog.failSystemError();
                    defer.reject();
                }
            });
            return defer.promise;
        }

        //获取当前已经添加的API详情
        function getOauthAPI(projectID, clientID) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID
                }
            };
            if (clientID) {
                params.req.clientID = clientID;
            }
            OpenApp.getOauthAPI(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function addOauthAPI(clientID, apiInfo) {
            var defer = $q.defer();
            var params = {
                req: {
                    clientID: clientID,
                    originService: 1
                }
            };
            if (apiInfo) {
                params.req.apiInfoList = [apiInfo];
            }
            OpenApp.addOauthAPI(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });

            return defer.promise;
        }

        function delOauthAPI(clientID, api) {
            var defer = $q.defer();
            var params = {
                req: {
                    apiList: [api],
                    clientID: clientID,
                    originService: 1
                }
            };
            OpenApp.delOauthAPI(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function modOauthAPI(clientID, apiInfo) {
            var defer = $q.defer();
            var params = {
                req: {
                    apiInfo: apiInfo,
                    clientID: clientID,
                    originService: 1
                }
            };
            OpenApp.modOauthAPI(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function getProSupOauthAPI(projectID) {
            var defer = $q.defer();
            getOauthAPI(projectID).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function delProject(projectID) {
            var defer = $q.defer();
            var params = {
                req: {
                    projectID: projectID,
                    originService: 1
                }
            };
            OpenApp.delProject(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.reject(resp);
            });
            return defer.promise;
        }

        function getAllCanAddApi(projectID, clientID) {
            var defer = $q.defer();
            getAllApiList().then(function (kitsApiList) {
                getOauthAPI(projectID, clientID).then(function (resp) {
                    if (resp && resp.oauthApiList && resp.oauthApiList.length > 0) {
                        var kitsApiListCopy = [];
                        kitsApiList.forEach(function (kitsApi) {
                            if (!AUI.BaseJSUtil.contains(getAddedApiArray(resp.oauthApiList), kitsApi.apiID)) {
                                kitsApiListCopy.push(kitsApi)
                            }
                        });
                        defer.resolve(kitsApiListCopy);
                    } else {
                        defer.resolve(kitsApiList);
                    }
                });
            })
            return defer.promise;
        }

        function getAddedApiArray(oauthApiList) {
            var addedApiArray = [];
            oauthApiList.forEach(function (oauthApi) {
                addedApiArray.push(oauthApi.apiID);
            });
            return addedApiArray;
        }


        function getApiSummaryList(projectID, Model) {
            var defer = $q.defer();
            OpenOther.getApiSummaryList({
                req: {
                    projectID: projectID,
                    dataRanges: [{
                        dateType: 'day',
                        dateValue: Model.query.day
                    }]
                }
            }).then(function (data) {
                // data={"pageCount":120,"apiSummaryInfoList":[{"maxDelay":2029071,"date":"20200412","name":"Map","errorTimes":10771,"requestTimes":1442,"id":"76","totalDelay":73982},{"maxDelay":2029072,"date":"20200413","name":"Map","errorTimes":10772,"requestTimes":4429349,"id":"76","totalDelay":73983},{"maxDelay":2029073,"date":"20200414","name":"Map","errorTimes":6000,"requestTimes":4429350,"id":"76","totalDelay":8298},{"maxDelay":3029074,"date":"20200415","name":"Map","errorTimes":10774,"requestTimes":4429351,"id":"76","totalDelay":73985},{"maxDelay":2001005,"date":"20200416","name":"Map","errorTimes":6047,"requestTimes":4429352,"id":"76","totalDelay":73986},{"maxDelay":2029076,"date":"20200417","name":"Map","errorTimes":10776,"requestTimes":4429353,"id":"76","totalDelay":73987},{"maxDelay":2029077,"date":"20200418","name":"Map","errorTimes":10777,"requestTimes":5428,"id":"76","totalDelay":1000},{"maxDelay":2029078,"date":"20200419","name":"Map","errorTimes":10778,"requestTimes":4429355,"id":"76","totalDelay":73989},{"maxDelay":2029079,"date":"20200420","name":"Map","errorTimes":18233,"requestTimes":4429356,"id":"76","totalDelay":73990},{"maxDelay":2029080,"date":"20200421","name":"Map","errorTimes":10780,"requestTimes":9357,"id":"76","totalDelay":63991},{"maxDelay":1202,"date":"20200422","name":"Map","errorTimes":6044,"requestTimes":4429358,"id":"76","totalDelay":73992},{"maxDelay":2029082,"date":"20200423","name":"Map","errorTimes":10782,"requestTimes":4429359,"id":"76","totalDelay":73993},{"maxDelay":2029083,"date":"20200424","name":"Map","errorTimes":10783,"requestTimes":1000,"id":"76","totalDelay":73994},{"maxDelay":2029084,"date":"20200425","name":"Map","errorTimes":39456,"requestTimes":9361,"id":"76","totalDelay":10343},{"maxDelay":1085,"date":"20200426","name":"Map","errorTimes":10785,"requestTimes":4429362,"id":"76","totalDelay":73996},{"maxDelay":2029086,"date":"20200427","name":"Map","errorTimes":10786,"requestTimes":1044,"id":"76","totalDelay":73997},{"maxDelay":3028,"date":"20200428","name":"Map","errorTimes":10787,"requestTimes":4429364,"id":"76","totalDelay":73998},{"maxDelay":2029088,"date":"20200429","name":"Map","errorTimes":10788,"requestTimes":1365,"id":"76","totalDelay":83999},{"maxDelay":2029089,"date":"20200430","name":"Map","errorTimes":6000,"requestTimes":4429366,"id":"76","totalDelay":74000},{"maxDelay":2029090,"date":"20200501","name":"Map","errorTimes":10790,"requestTimes":4429367,"id":"76","totalDelay":74001},{"maxDelay":2029091,"date":"20200502","name":"Map","errorTimes":10791,"requestTimes":4429368,"id":"76","totalDelay":74002},{"maxDelay":2029092,"date":"20200503","name":"Map","errorTimes":10792,"requestTimes":4429369,"id":"76","totalDelay":74003},{"maxDelay":2029093,"date":"20200504","name":"Map","errorTimes":10793,"requestTimes":4429370,"id":"76","totalDelay":74004},{"maxDelay":1202,"date":"20200505","name":"Map","errorTimes":10794,"requestTimes":4429371,"id":"76","totalDelay":74005},{"maxDelay":203809,"date":"20200506","name":"Map","errorTimes":10795,"requestTimes":4429372,"id":"76","totalDelay":74006},{"maxDelay":2029096,"date":"20200507","name":"Map","errorTimes":10796,"requestTimes":4429373,"id":"76","totalDelay":74007},{"maxDelay":2029097,"date":"20200508","name":"Map","errorTimes":10797,"requestTimes":4429374,"id":"76","totalDelay":74008},{"maxDelay":1000,"date":"20200509","name":"Map","errorTimes":10798,"requestTimes":4429375,"id":"76","totalDelay":74009},{"maxDelay":2029099,"date":"20200510","name":"Map","errorTimes":10799,"requestTimes":4429376,"id":"76","totalDelay":74010},{"maxDelay":2029100,"date":"20200511","name":"Map","errorTimes":10800,"requestTimes":4429377,"id":"76","totalDelay":74011},{"maxDelay":2036071,"date":"20200412","name":"machine","errorTimes":7771,"requestTimes":3442,"id":"87","totalDelay":75982},{"maxDelay":2036072,"date":"20200413","name":"machine","errorTimes":7772,"requestTimes":4431349,"id":"87","totalDelay":75983},{"maxDelay":2036073,"date":"20200414","name":"machine","errorTimes":3000,"requestTimes":4431350,"id":"87","totalDelay":10298},{"maxDelay":3036074,"date":"20200415","name":"machine","errorTimes":7774,"requestTimes":4431351,"id":"87","totalDelay":75985},{"maxDelay":2008005,"date":"20200416","name":"machine","errorTimes":3047,"requestTimes":4431352,"id":"87","totalDelay":75986},{"maxDelay":2036076,"date":"20200417","name":"machine","errorTimes":7776,"requestTimes":4431353,"id":"87","totalDelay":75987},{"maxDelay":2036077,"date":"20200418","name":"machine","errorTimes":7777,"requestTimes":7428,"id":"87","totalDelay":3000},{"maxDelay":2036078,"date":"20200419","name":"machine","errorTimes":7778,"requestTimes":4431355,"id":"87","totalDelay":75989},{"maxDelay":2036079,"date":"20200420","name":"machine","errorTimes":15233,"requestTimes":4431356,"id":"87","totalDelay":75990},{"maxDelay":2036080,"date":"20200421","name":"machine","errorTimes":7780,"requestTimes":11357,"id":"87","totalDelay":65991},{"maxDelay":8202,"date":"20200422","name":"machine","errorTimes":3044,"requestTimes":4431358,"id":"87","totalDelay":75992},{"maxDelay":2036082,"date":"20200423","name":"machine","errorTimes":7782,"requestTimes":4431359,"id":"87","totalDelay":75993},{"maxDelay":2036083,"date":"20200424","name":"machine","errorTimes":7783,"requestTimes":3000,"id":"87","totalDelay":75994},{"maxDelay":2036084,"date":"20200425","name":"machine","errorTimes":36456,"requestTimes":11361,"id":"87","totalDelay":12343},{"maxDelay":8085,"date":"20200426","name":"machine","errorTimes":7785,"requestTimes":4431362,"id":"87","totalDelay":75996},{"maxDelay":2036086,"date":"20200427","name":"machine","errorTimes":7786,"requestTimes":3044,"id":"87","totalDelay":75997},{"maxDelay":10028,"date":"20200428","name":"machine","errorTimes":7787,"requestTimes":4431364,"id":"87","totalDelay":75998},{"maxDelay":2036088,"date":"20200429","name":"machine","errorTimes":7788,"requestTimes":3365,"id":"87","totalDelay":85999},{"maxDelay":2036089,"date":"20200430","name":"machine","errorTimes":3000,"requestTimes":4431366,"id":"87","totalDelay":76000},{"maxDelay":2036090,"date":"20200501","name":"machine","errorTimes":7790,"requestTimes":4431367,"id":"87","totalDelay":76001},{"maxDelay":2036091,"date":"20200502","name":"machine","errorTimes":7791,"requestTimes":4431368,"id":"87","totalDelay":76002},{"maxDelay":2036092,"date":"20200503","name":"machine","errorTimes":7792,"requestTimes":4431369,"id":"87","totalDelay":76003},{"maxDelay":2036093,"date":"20200504","name":"machine","errorTimes":7793,"requestTimes":4431370,"id":"87","totalDelay":76004},{"maxDelay":8202,"date":"20200505","name":"machine","errorTimes":7794,"requestTimes":4431371,"id":"87","totalDelay":76005},{"maxDelay":210809,"date":"20200506","name":"machine","errorTimes":7795,"requestTimes":4431372,"id":"87","totalDelay":76006},{"maxDelay":2036096,"date":"20200507","name":"machine","errorTimes":7796,"requestTimes":4431373,"id":"87","totalDelay":76007},{"maxDelay":2036097,"date":"20200508","name":"machine","errorTimes":7797,"requestTimes":4431374,"id":"87","totalDelay":76008},{"maxDelay":8000,"date":"20200509","name":"machine","errorTimes":7798,"requestTimes":4431375,"id":"87","totalDelay":76009},{"maxDelay":2036099,"date":"20200510","name":"machine","errorTimes":7799,"requestTimes":4431376,"id":"87","totalDelay":76010},{"maxDelay":2036100,"date":"20200511","name":"machine","errorTimes":7800,"requestTimes":4431377,"id":"87","totalDelay":76011},{"maxDelay":2030071,"date":"20200412","name":"location","errorTimes":6771,"requestTimes":2442,"id":"90","totalDelay":74982},{"maxDelay":2030072,"date":"20200413","name":"location","errorTimes":6772,"requestTimes":4430349,"id":"90","totalDelay":74983},{"maxDelay":2030073,"date":"20200414","name":"location","errorTimes":2000,"requestTimes":4430350,"id":"90","totalDelay":9298},{"maxDelay":3030074,"date":"20200415","name":"location","errorTimes":6774,"requestTimes":4430351,"id":"90","totalDelay":74985},{"maxDelay":2002005,"date":"20200416","name":"location","errorTimes":2047,"requestTimes":4430352,"id":"90","totalDelay":74986},{"maxDelay":2030076,"date":"20200417","name":"location","errorTimes":6776,"requestTimes":4430353,"id":"90","totalDelay":74987},{"maxDelay":2030077,"date":"20200418","name":"location","errorTimes":6777,"requestTimes":6428,"id":"90","totalDelay":2000},{"maxDelay":2030078,"date":"20200419","name":"location","errorTimes":6778,"requestTimes":4430355,"id":"90","totalDelay":74989},{"maxDelay":2030079,"date":"20200420","name":"location","errorTimes":14233,"requestTimes":4430356,"id":"90","totalDelay":74990},{"maxDelay":2030080,"date":"20200421","name":"location","errorTimes":6780,"requestTimes":10357,"id":"90","totalDelay":64991},{"maxDelay":2202,"date":"20200422","name":"location","errorTimes":2044,"requestTimes":4430358,"id":"90","totalDelay":74992},{"maxDelay":2030082,"date":"20200423","name":"location","errorTimes":6782,"requestTimes":4430359,"id":"90","totalDelay":74993},{"maxDelay":2030083,"date":"20200424","name":"location","errorTimes":6783,"requestTimes":2000,"id":"90","totalDelay":74994},{"maxDelay":2030084,"date":"20200425","name":"location","errorTimes":35456,"requestTimes":10361,"id":"90","totalDelay":11343},{"maxDelay":2085,"date":"20200426","name":"location","errorTimes":6785,"requestTimes":4430362,"id":"90","totalDelay":74996},{"maxDelay":2030086,"date":"20200427","name":"location","errorTimes":6786,"requestTimes":2044,"id":"90","totalDelay":74997},{"maxDelay":4028,"date":"20200428","name":"location","errorTimes":6787,"requestTimes":4430364,"id":"90","totalDelay":74998},{"maxDelay":2030088,"date":"20200429","name":"location","errorTimes":6788,"requestTimes":2365,"id":"90","totalDelay":84999},{"maxDelay":2030089,"date":"20200430","name":"location","errorTimes":2000,"requestTimes":4430366,"id":"90","totalDelay":75000},{"maxDelay":2030090,"date":"20200501","name":"location","errorTimes":6790,"requestTimes":4430367,"id":"90","totalDelay":75001},{"maxDelay":2030091,"date":"20200502","name":"location","errorTimes":6791,"requestTimes":4430368,"id":"90","totalDelay":75002},{"maxDelay":2030092,"date":"20200503","name":"location","errorTimes":6792,"requestTimes":4430369,"id":"90","totalDelay":75003},{"maxDelay":2030093,"date":"20200504","name":"location","errorTimes":6793,"requestTimes":4430370,"id":"90","totalDelay":75004},{"maxDelay":2202,"date":"20200505","name":"location","errorTimes":6794,"requestTimes":4430371,"id":"90","totalDelay":75005},{"maxDelay":204809,"date":"20200506","name":"location","errorTimes":6795,"requestTimes":4430372,"id":"90","totalDelay":75006},{"maxDelay":2030096,"date":"20200507","name":"location","errorTimes":6796,"requestTimes":4430373,"id":"90","totalDelay":75007},{"maxDelay":2030097,"date":"20200508","name":"location","errorTimes":6797,"requestTimes":4430374,"id":"90","totalDelay":75008},{"maxDelay":2000,"date":"20200509","name":"location","errorTimes":6798,"requestTimes":4430375,"id":"90","totalDelay":75009},{"maxDelay":2030099,"date":"20200510","name":"location","errorTimes":6799,"requestTimes":4430376,"id":"90","totalDelay":75010},{"maxDelay":2030100,"date":"20200511","name":"location","errorTimes":6800,"requestTimes":4430377,"id":"90","totalDelay":75011},{"maxDelay":2033071,"date":"20200412","name":"NearbyService","errorTimes":9771,"requestTimes":442,"id":"94","totalDelay":72982},{"maxDelay":2033072,"date":"20200413","name":"NearbyService","errorTimes":9772,"requestTimes":4428349,"id":"94","totalDelay":72983},{"maxDelay":2033073,"date":"20200414","name":"NearbyService","errorTimes":5000,"requestTimes":4428350,"id":"94","totalDelay":7298},{"maxDelay":3033074,"date":"20200415","name":"NearbyService","errorTimes":9774,"requestTimes":4428351,"id":"94","totalDelay":72985},{"maxDelay":2005005,"date":"20200416","name":"NearbyService","errorTimes":5047,"requestTimes":4428352,"id":"94","totalDelay":72986},{"maxDelay":2033076,"date":"20200417","name":"NearbyService","errorTimes":9776,"requestTimes":4428353,"id":"94","totalDelay":72987},{"maxDelay":2033077,"date":"20200418","name":"NearbyService","errorTimes":9777,"requestTimes":4428,"id":"94","totalDelay":0},{"maxDelay":2033078,"date":"20200419","name":"NearbyService","errorTimes":9778,"requestTimes":4428355,"id":"94","totalDelay":72989},{"maxDelay":2033079,"date":"20200420","name":"NearbyService","errorTimes":17233,"requestTimes":4428356,"id":"94","totalDelay":72990},{"maxDelay":2033080,"date":"20200421","name":"NearbyService","errorTimes":9780,"requestTimes":8357,"id":"94","totalDelay":62991},{"maxDelay":5202,"date":"20200422","name":"NearbyService","errorTimes":5044,"requestTimes":4428358,"id":"94","totalDelay":72992},{"maxDelay":2033082,"date":"20200423","name":"NearbyService","errorTimes":9782,"requestTimes":4428359,"id":"94","totalDelay":72993},{"maxDelay":2033083,"date":"20200424","name":"NearbyService","errorTimes":9783,"requestTimes":0,"id":"94","totalDelay":72994},{"maxDelay":2033084,"date":"20200425","name":"NearbyService","errorTimes":38456,"requestTimes":8361,"id":"94","totalDelay":9343},{"maxDelay":5085,"date":"20200426","name":"NearbyService","errorTimes":9785,"requestTimes":4428362,"id":"94","totalDelay":72996},{"maxDelay":2033086,"date":"20200427","name":"NearbyService","errorTimes":9786,"requestTimes":44,"id":"94","totalDelay":72997},{"maxDelay":7028,"date":"20200428","name":"NearbyService","errorTimes":9787,"requestTimes":4428364,"id":"94","totalDelay":72998},{"maxDelay":2033088,"date":"20200429","name":"NearbyService","errorTimes":9788,"requestTimes":365,"id":"94","totalDelay":82999},{"maxDelay":2033089,"date":"20200430","name":"NearbyService","errorTimes":5000,"requestTimes":4428366,"id":"94","totalDelay":73000},{"maxDelay":2033090,"date":"20200501","name":"NearbyService","errorTimes":9790,"requestTimes":4428367,"id":"94","totalDelay":73001},{"maxDelay":2033091,"date":"20200502","name":"NearbyService","errorTimes":9791,"requestTimes":4428368,"id":"94","totalDelay":73002},{"maxDelay":2033092,"date":"20200503","name":"NearbyService","errorTimes":9792,"requestTimes":4428369,"id":"94","totalDelay":73003},{"maxDelay":2033093,"date":"20200504","name":"NearbyService","errorTimes":9793,"requestTimes":4428370,"id":"94","totalDelay":73004},{"maxDelay":5202,"date":"20200505","name":"NearbyService","errorTimes":9794,"requestTimes":4428371,"id":"94","totalDelay":73005},{"maxDelay":207809,"date":"20200506","name":"NearbyService","errorTimes":9795,"requestTimes":4428372,"id":"94","totalDelay":73006},{"maxDelay":2033096,"date":"20200507","name":"NearbyService","errorTimes":9796,"requestTimes":4428373,"id":"94","totalDelay":73007},{"maxDelay":2033097,"date":"20200508","name":"NearbyService","errorTimes":9797,"requestTimes":4428374,"id":"94","totalDelay":73008},{"maxDelay":5000,"date":"20200509","name":"NearbyService","errorTimes":9798,"requestTimes":4428375,"id":"94","totalDelay":73009},{"maxDelay":2033099,"date":"20200510","name":"NearbyService","errorTimes":9799,"requestTimes":4428376,"id":"94","totalDelay":73010},{"maxDelay":2033100,"date":"20200511","name":"NearbyService","errorTimes":9800,"requestTimes":4428377,"id":"94","totalDelay":73011}],"resultCode":0}
                var reports = {};
                reports.requestIds = [];
                reports.errorIds = [];
                reports.maxIds = [];
                reports.requestNames = [];
                reports.errorNames = [];
                reports.maxNames = [];
                reports.requestData = [];
                reports.errorData = [];
                reports.maxData = [];
                reports.dates = [];
                reports.listForApi = {};
                if (data && data.apiSummaryInfoList && data.apiSummaryInfoList.length > 0) {
                    data.apiSummaryInfoList.sort(AUI.BaseJSUtil.arrObjCompare("date"));
                    data.apiSummaryInfoList.forEach(function (ability) {
                        if (!AUI.BaseJSUtil.contains(reports.requestIds, ability.id)) {
                            reports.listForApi[ability.id] = {};
                            reports.listForApi[ability.id]['requestTimes'] = 0;
                            reports.listForApi[ability.id]['errorTimes'] = 0;
                            reports.listForApi[ability.id]['maxDelay'] = 0;
                            reports.listForApi[ability.id]['totalDelay'] = 0;
                            reports.requestIds.push(ability.id);
                        }
                        if (!AUI.BaseJSUtil.contains(reports.errorIds, ability.id)) {
                            reports.errorIds.push(ability.id);
                        }
                        if (!AUI.BaseJSUtil.contains(reports.maxIds, ability.id)) {
                            reports.maxIds.push(ability.id);
                        }
                        if (!AUI.BaseJSUtil.contains(reports.dates, ability.date)) {
                            reports.dates.push(ability.date);
                        }
                    });
                    reports.dates.forEach(function (date) {
                        var requestSingle = {};
                        var errorSingle = {};
                        var maxSingle = {};
                        requestSingle['date'] = date;
                        errorSingle['date'] = date;
                        maxSingle['date'] = date;
                        reports.requestIds.forEach(function (id) {
                            data.apiSummaryInfoList.forEach(function (ability) {
                                if (ability.date == date && ability.id == id) {
                                    requestSingle[id + ""] = ability.requestTimes;
                                    errorSingle[id + ""] = ability.errorTimes;
                                    maxSingle[id + ""] = ability.maxDelay;
                                    reports.listForApi[ability.id + ""]['requestTimes'] = parseInt(reports.listForApi[ability.id]['requestTimes']) + parseInt(ability.requestTimes);
                                    reports.listForApi[ability.id + ""]['errorTimes'] = parseInt(reports.listForApi[ability.id]['errorTimes']) + parseInt(ability.errorTimes);
                                    reports.listForApi[ability.id + ""]['maxDelay'] = parseInt(reports.listForApi[ability.id]['maxDelay']) + parseInt(ability.maxDelay);
                                    reports.listForApi[ability.id + ""]['totalDelay'] = parseInt(reports.listForApi[ability.id]['totalDelay']) + parseInt(ability.totalDelay);
                                }
                            });
                        });
                        reports.requestData.push(requestSingle);
                        reports.errorData.push(errorSingle);
                        reports.maxData.push(maxSingle);
                        reports.apiListData = [];
                        for (var i in reports.listForApi) {
                            reports.listForApi[i].id = i;
                            reports.apiListData.push(reports.listForApi[i]); //属性
                        }

                    });
                    defer.resolve(reports);
                } else {
                    defer.resolve();
                }
            }).catch(function () {
                defer.reject();
            });
            return defer.promise;
        }

        function getApiMetricList(getApiMetricReq) {
            var defer = $q.defer();
            var apiMetricType = angular.copy(getApiMetricReq);
            OpenOther.getApiMetricList({
                req: getApiMetricReq
            }).then(function (data) {
                /*  data = {
                 "metricInfoList": [{
                 "indicator": "620.13213",
                 "date": "20200501",
                 "dimension": "/v1/image/recognition/landmark"
                 }, {
                 "indicator": "583.13213",
                 "date": "20200501",
                 "dimension": "/v1/image/recognition/ocr/idcard"
                 }, {
                 "indicator": "609.13213",
                 "date": "20200501",
                 "dimension": "/v1/translation/language/feedback"
                 }, {
                 "indicator": "1066.13213",
                 "date": "20200501",
                 "dimension": "MLKitIcrQualityAssessment"
                 }, {
                 "indicator": "466.13213",
                 "date": "20200501",
                 "dimension": "MLKitOCR"
                 }, {
                 "indicator": "605.13213",
                 "date": "20200501",
                 "dimension": "/v1/translation/language/supported"
                 }, {
                 "indicator": "623.13213",
                 "date": "20200501",
                 "dimension": "/v1/image/recognition/ocr/text"
                 }, {
                 "indicator": "30.13213",
                 "date": "20200501",
                 "dimension": "MLKitLabel"
                 }, {
                 "indicator": "573.13213",
                 "date": "20200501",
                 "dimension": "/v1/translation/language/detect"
                 }, {
                 "indicator": "37.13213",
                 "date": "20200501",
                 "dimension": "MLKitImgSeg"
                 }, {
                 "indicator": "280.13213",
                 "date": "20200501",
                 "dimension": "/v1/image/recognition/snapshop"
                 }, {
                 "indicator": "74.13213",
                 "date": "20200501",
                 "dimension": "MLKitFace-Landmark-Contour"
                 }, {
                 "indicator": "610.13213",
                 "date": "20200501",
                 "dimension": "/v1/image/recognition/label"
                 }, {
                 "indicator": "620.13213",
                 "date": "20200501",
                 "dimension": "/v1/image/recognition/ocr/document"
                 }, {
                 "indicator": "7985.13213",
                 "date": "20200501",
                 "dimension": "/v1/translation/language/translate"
                 }, {
                 "indicator": "3438.13213",
                 "date": "20200501",
                 "dimension": "MLKitLensEngine"
                 }, {
                 "indicator": "87.13213",
                 "date": "20200501",
                 "dimension": "MLKitGcrQualityAssessment"
                 }, {
                 "indicator": "566.13213",
                 "date": "20200501",
                 "dimension": "/v1/images:annotate"
                 }, {
                 "indicator": "87.13213",
                 "date": "20200501",
                 "dimension": "MLKitBCR"
                 }, {
                 "indicator": "2723.13213",
                 "date": "20200501",
                 "dimension": "MLKitCNICR"
                 }, {
                 "indicator": "1277.13213",
                 "date": "20200501",
                 "dimension": "MLKitFace-Contour"
                 }, {
                 "indicator": "287.13213",
                 "date": "20200501",
                 "dimension": "MLKitObject"
                 }],
                 "metric": 2,
                 "resultCode": 0,
                 "type": 2
                 }*/
                var deferData = {};
                if (data && data.metricInfoList && data.metricInfoList.length > 0) {
                    data.metricInfoList.sort(AUI.BaseJSUtil.arrObjCompare("date"));
                    defer.resolve(getReportData(data));
                } else {
                    deferData.metricInfoList = [];
                    deferData.metricInfoListData = data.metricInfoList;
                    deferData.series = [{
                        "name": []
                    }];
                    defer.resolve(deferData);
                }
            }).catch(function () {
                defer.reject();
            });
            return defer.promise;

        }

        function getReportData(data) {
            var deferData = {};
            var metricInfoList = [];
            var metricInfoListDimension = [];
            var dimensionList = [];
            data.metricInfoList.forEach(function (metricInfo) {
                if (!AUI.BaseJSUtil.contains(metricInfoListDimension, metricInfo.dimension)) {
                    metricInfoListDimension.push(metricInfo.dimension);
                }
                metricInfo.indicator = parseInt(metricInfo.indicator);
            });
            metricInfoListDimension.forEach(function (dimension) {
                metricInfoList.push({
                    "indicator": 0,
                    "dimension": dimension
                })
            });
            data.metricInfoList.forEach(function (metricInfo) {
                metricInfoList.forEach(function (metricInfoSingle) {
                    if (metricInfoSingle.dimension == metricInfo.dimension) {
                        metricInfoSingle.indicator += parseFloat(metricInfo.indicator);
                    }
                })
            });
            //正序 从小到大
            metricInfoList.sort(AUI.BaseJSUtil.arrObjCompare("indicator"));
            if (metricInfoList.length > 3) {
                dimensionList = [metricInfoList[metricInfoList.length - 3].dimension, metricInfoList[metricInfoList.length - 2].dimension, metricInfoList[metricInfoList.length - 1].dimension];
            } else {
                metricInfoList.forEach(function (metricInfo) {
                    dimensionList.push(metricInfo.dimension);
                })
            }

            var metricInfoListReport = [];
            data.metricInfoList.forEach(function (metricInfo) {
                dimensionList.forEach(function (dimension) {
                    if (dimension == metricInfo.dimension) {
                        metricInfoListReport.push(metricInfo);
                    }
                })
            });

            deferData.metricInfoListData = data.metricInfoList;
            deferData.dimensionList = dimensionList;
            var dateList = [];
            var metricInfoListReportList = [];
            metricInfoListReport.forEach(function (metricInfo) {
                if (!AUI.BaseJSUtil.contains(dateList, metricInfo.date)) {
                    dateList.push(metricInfo.date);
                }
            });

            dateList.forEach(function (date) {
                var singleData = {};
                singleData.date = date;
                dimensionList.forEach(function (dimension) {
                    singleData[dimension] = 0;
                })
                metricInfoListReportList.push(singleData);
            })
            metricInfoListReport.forEach(function (metricInfo) {
                metricInfoListReportList.forEach(function (metricInfoListReport) {
                    if (metricInfo.date == metricInfoListReport.date) {
                        metricInfoListReport[metricInfo.dimension + ""] = metricInfo.indicator;
                    }
                })
            });
            metricInfoListReportList.sort(AUI.BaseJSUtil.arrObjCompare('date'));
            metricInfoListReportList.reverse();

            deferData.metricInfoListData.sort(AUI.BaseJSUtil.arrObjCompare('date'));
            deferData.metricInfoListData.reverse();
            var sheetTitle = {};
            sheetTitle.date = "时间";
            if (data.type == 1 && data.metric == 3) {
                sheetTitle.indicator = "流量";
                sheetTitle.dimension = "响应码";
            } else if (data.type == 2 && data.metric == 2) {
                sheetTitle.indicator = "流量";
                sheetTitle.dimension = "方法";
            } else if (data.type == 2 && data.metric == 3) {
                sheetTitle.indicator = "错误数";
                sheetTitle.dimension = "方法";
            } else if (data.type == 1 && data.metric == 1) {
                sheetTitle.indicator = "平均时延（ms）";
                sheetTitle.dimension = "响应码";
            } else if (data.type == 2 && data.metric == 1) {
                sheetTitle.indicator = "平均时延（ms）";
                sheetTitle.dimension = "方法";
            } else {
                sheetTitle.indicator = "维度值";
                sheetTitle.dimension = "维度";
            }
            deferData.metricInfoListData.push(sheetTitle);
            deferData.metricInfoListData.reverse();
            deferData.metricInfoListReport = metricInfoListReportList;
            return deferData;

        }

        function getApiVersionList(getApiVersionReq) {
            var defer = $q.defer();

            OpenOther.getApiVersionList({
                req: getApiVersionReq
            }).then(function (data) {
                if (data && data.apiVersionInfoList && data.apiVersionInfoList.length > 0) {
                    var apiVersionInfoList = [];
                    var VersionInfoList = [];
                    data.apiVersionInfoList.forEach(function (apiVersionInfo) {
                        if (!AUI.BaseJSUtil.contains(VersionInfoList, apiVersionInfo.apiVersion)) {
                            VersionInfoList.push(apiVersionInfo.apiVersion);
                            apiVersionInfoList.push(apiVersionInfo);
                        }
                    });
                    data.apiVersionInfoList = angular.copy(apiVersionInfoList);
                    defer.resolve(data)
                } else {
                    defer.resolve();
                }
            }).catch(function () {
                defer.reject();
            });
            return defer.promise;

        }

        function getMethodSummaryList(getMethodSummaryReq) {
            var defer = $q.defer();
            OpenOther.getMethodSummaryList({
                req: getMethodSummaryReq
            }).then(function (data) {
                if (data && data.methodSummaryInfoList && data.methodSummaryInfoList.length > 0) {
                    data.methodSummaryInfoList.sort(AUI.BaseJSUtil.arrObjCompare("date"));
                    var methodSummaryList = [];
                    var methodSummaryListName = [];
                    data.methodSummaryInfoList.forEach(function (methodSummaryInfo) {
                        if (!AUI.BaseJSUtil.contains(methodSummaryListName, methodSummaryInfo.name)) {
                            methodSummaryListName.push(methodSummaryInfo.name);
                        }
                    });
                    methodSummaryListName.forEach(function (name) {
                        methodSummaryList.push({
                            "maxDelay": 0,
                            "name": name,
                            "errorTimes": 0,
                            "requestTimes": 0,
                            "totalDelay": 0
                        })
                    });
                    data.methodSummaryInfoList.forEach(function (methodSummaryInfo) {
                        methodSummaryList.forEach(function (methodSummary) {
                            if (methodSummary.name == methodSummaryInfo.name) {
                                methodSummary.maxDelay += methodSummaryInfo.maxDelay;
                                methodSummary.errorTimes += methodSummaryInfo.errorTimes;
                                methodSummary.requestTimes += methodSummaryInfo.requestTimes;
                                methodSummary.totalDelay += methodSummaryInfo.totalDelay;
                            }
                        })
                    });
                    defer.resolve(methodSummaryList);
                } else {
                    defer.resolve([]);
                }
            }).catch(function () {
                defer.reject();
            });
            return defer.promise;

        }

        function getChartOptions(text, data, series) {
            return {
                title: {
                    left: 'center',
                    text: text
                },
                legend: {
                    data: []
                },
                xAxis: [{ // 横坐标
                    type: 'category', data: data
                }],
                yAxis: [{ // 纵坐标
                    type: 'value'
                }],
                toolbox: {
                    show: true,
                    feature: {
                        magicType: {show: false, type: ['line']},
                        restore: {show: false},
                        myTool: {}
                    }
                },
                dataZoom: {show: false},
                series: series
            }
        }

        function queryProcessContact(request) {
            var defer = $q.defer();
            var params = {
                req: request
            };
            OpenOther.queryProcessContact(params).then(function (resp) {
                if (resp && resp.contactInfoList && resp.contactInfoList.length > 0) {
                    var projectIDs = [];
                    resp.contactInfoList.forEach(function (contactInfo) {
                        if (!AUI.BaseJSUtil.contains(projectIDs, contactInfo.projectID) && contactInfo.projectID != -1) {
                            projectIDs.push(contactInfo.projectID);
                        }
                    });
                    if (projectIDs.length > 0) {
                        getProjectListByID({projectIDList: projectIDs}).then(function (data) {
                            if (data && data.projectInfoList && data.projectInfoList.length > 0) {
                                resp.contactInfoList.forEach(function (contactInfo) {
                                    data.projectInfoList.forEach(function (projectInfo) {
                                        if (contactInfo.projectID == projectInfo.projectID) {
                                            contactInfo.projectName = projectInfo.projectName;
                                        } else if (contactInfo.projectID == '-1') {
                                            contactInfo.projectName = "所有项目";
                                        }
                                    })
                                });
                                defer.resolve(resp);
                            }
                        }).catch(function () {
                            defer.resolve(resp);
                        })
                    } else {
                        resp.contactInfoList.forEach(function (contactInfo) {
                            if (contactInfo.projectID == '-1') {
                                contactInfo.projectName = "所有项目";
                            }
                        });
                        defer.resolve(resp);
                    }
                } else {
                    defer.resolve(resp);
                }
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function getProjectListByID(request) {
            var defer = $q.defer();
            var params = {
                req: request
            };
            OpenApp.getProjectListByID(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }


        function addProcessContact(request) {
            var defer = $q.defer();
            var params = {
                req: request
            };
            OpenOther.addProcessContact(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function delProcessContact(request) {
            var defer = $q.defer();
            var params = {
                req: request
            };
            OpenOther.delProcessContact(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function modProcessContact(request) {
            var defer = $q.defer();
            var params = {
                req: request
            };
            OpenOther.modProcessContact(params).then(function (resp) {
                defer.resolve(resp);
            }).catch(function (resp) {
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function addContactInfoPage() {
            var defer = $q.defer();
            var handle = ngDialog.open({
                template: 'pages/consoleApi/template/privacy.contactors.set.html',
                className: '',
                controller: ['$scope', function ($scope) {
                    var Model = $scope.Model = {};
                    $scope.isAdd = true;
                    $scope.contactTypes = mainCons.oauthConstant.contactTypes;
                    $scope.getProjectListAbs = getProjectListAbs;
                    $scope.setInputDirty = setInputDirty;
                    getProjectListAbs();
                    $scope.setContacter = function () {
                        var deferTemp = $q.defer();
                        var request = {
                            contactInfo: {
                                projectID: Model.checkedProject.projectID,
                                contactType: Model.checkedContactType.key,
                                contactName: Model.contactName,
                                contactEmail: Model.contactEmail,
                                contactPhone: Model.contactPhone,
                                contactAddress: Model.contactAddress
                            }
                        }
                        addProcessContact(request).then(function (resp) {
                            if (resp && resp.resultCode == 0) {
                                auiDialog.success("添加成功", function () {
                                    deferTemp.resolve();
                                    defer.resolve(resp);
                                    handle.close();
                                })
                            } else {
                                deferTemp.reject(resp);
                            }
                        });
                        return deferTemp.promise;
                    };
                    $scope.cancel = function () {
                        defer.resolve();
                        handle.close();
                    }

                    function getProjectListAbs(searchTxt) {

                        var req = {};
                        if (searchTxt) {
                            req.searchTxt = searchTxt;
                        }
                        getProjectList(req).then(function (resp) {
                            if (resp && resp.projectInfoList && resp.projectInfoList.length > 0) {
                                Model.projectList = [{projectName: '所有项目', projectID: '-1'}];
                                Model.projectList = Model.projectList.concat(resp.projectInfoList);
                            } else {
                                Model.projectList = [{projectName: '所有项目', projectID: '-1'}];
                            }
                        })
                    }


                }]
            });
            return defer.promise;
        }

        function modContactInfoPage(row) {
            var defer = $q.defer();
            var handle = ngDialog.open({
                template: 'pages/consoleApi/template/privacy.contactors.set.html',
                className: '',
                controller: ['$scope', function ($scope) {
                    $scope.isAdd = false;
                    var Model = $scope.Model = row;
                    Model.contactTypeFilter = mainCons.oauthConstant.contactTypeFilter;
                    $scope.setInputDirty = setInputDirty;
                    $scope.setContacter = function () {
                        var deferTemp = $q.defer();
                        var request = {
                            contactInfo: {
                                projectID: row.projectID,
                                contactType: row.contactType,
                                contactName: Model.contactName,
                                contactEmail: Model.contactEmail,
                                contactPhone: Model.contactPhone,
                                contactAddress: Model.contactAddress,
                                contactID: row.contactID
                            }
                        }
                        modProcessContact(request).then(function (resp) {
                            if (resp && resp.resultCode == 0) {
                                auiDialog.success("修改成功", function () {
                                    deferTemp.resolve();
                                    defer.resolve(resp);
                                    handle.close();
                                });
                            } else {
                                deferTemp.reject();
                            }
                        });
                        return deferTemp.promise;
                    };
                    $scope.cancel = function () {
                        defer.resolve();
                        handle.close();
                    }
                }]
            });
            return defer.promise;
        }

        function setInputDirty(contactForm) {
            for (var key in contactForm) {
                if (Object.prototype.hasOwnProperty.call(contactForm, key) === true && key.indexOf('$') < 0) {
                    contactForm[key].$setDirty();
                }
            }
        }

        function managerPro(attrs, $stateParams, Model) {
            var handle = ngDialog.open({
                template: 'pages/consoleApi/template/project.list.html',
                className: '',
                controller: ['$scope', function ($scope) {
                    $scope.checkKey = function (project) {
                        $scope.selected = project.projectKey;
                    };
                    $scope.paginationMessage = {
                        currentPage: 1,// 当前页
                        itemsPerPage: 10,// 默认每页个数
                        totalCount: 0,
                        noItems: "没有项目",
                        pagesLength: 10,// 显示的页码数量,
                        onChange: getProjectListPage,
                        hidePage: 'hide'
                    };
                    $scope.searchProject = searchProject;
                    $scope.close = close;
                    $scope.createProject = createProjectPage;
                    $scope.conform = conform;
                    $scope.delProject = delProjectPage;
                    $scope.leftProjectQuotaPage = 0;
                    $scope.getOperation = getOperation;

                    function getOperation(project) {
                        if (project && project.originService == 1) {
                            return "删除";
                        } else {
                            return "";
                        }
                    }

                    getProjectListPage();

                    function searchProject() {
                        $scope.paginationMessage.currentPage = 1;
                        getProjectListPage();
                    }

                    function getProjectListPage() {

                        var param = {};
                        var defer = $q.defer();
                        if ($scope.searchTxt) {
                            param.searchTxt = $scope.searchTxt;
                        }
                        param.fromRecCount = (1 + ($scope.paginationMessage.currentPage - 1) * $scope.paginationMessage.itemsPerPage);
                        param.maxReqCount = ($scope.paginationMessage.itemsPerPage);
                        getProjectList(param).then(function (resp) {
                            $scope.leftProjectQuotaPage = angular.copy(resp.leftProjectQuota);
                            if (resp && resp.projectInfoList && resp.projectInfoList.length > 0) {
                                $scope.projectInfoList = angular.copy(resp.projectInfoList);
                                $scope.paginationMessage.totalCount = resp.totalCount;
                                if (Model.projectKey == '0') {
                                    $scope.selected = resp.projectInfoList[0].projectKey;
                                    defer.resolve();
                                } else {
                                    if (AUI.BaseJSUtil.contains($scope.projectInfoList, Model.projectKey)) {
                                        $scope.selected = Model.projectKey;
                                    } else {
                                        $scope.selected = resp.projectInfoList[0].projectKey;
                                    }
                                    defer.resolve();
                                }
                            } else {
                                $scope.projectInfoList = [];
                                $scope.paginationMessage.totalCount = 0;
                                defer.reject();
                            }
                        })
                        return defer.promise;
                    }

                    function close() {
                        handle.close();
                    }

                    function createProjectPage() {
                        //创建完成后更新缓存
                        createProject().then(function () {
                            $scope.searchTxt = '';
                            $scope.paginationMessage.currentPage = 1;
                            getProjectListPage();
                        });
                    }

                    function delProjectPage(project) {
                        if (project && project.originService != 1) return;
                        var defer = $q.defer();
                        auiDialog.confirm("确定删除当前项目？", function () {
                            delProject(project.projectID).then(function (resp) {
                                defer.reject();
                                if (resp && resp.resultCode == 0) {
                                    auiDialog.success("删除成功", function () {
                                        getProjectListPage().then(function () {
                                            if (project.projectKey == Model.projectKey) {
                                                changeProjectFun(attrs, $stateParams, $scope.selected);
                                            }
                                        }).catch(function () {
                                            setProjectKey('0');
                                            $state.go('myProject', {reload: true});
                                        });

                                    })
                                }
                            }).catch(function () {
                                defer.reject();
                            })
                        }, function () {
                            defer.reject();
                        });
                        return defer.promise;
                    }

                    function conform() {
                        if (Model.projectKey != $scope.selected) {
                            handle.close();
                            changeProjectFun(attrs, $stateParams, $scope.selected);
                        } else {
                            close();
                        }
                    }
                }]
            });
        }

        function changeProjectFun(attrs, stateParams, projectKey) {
            setProjectKey(projectKey);
            if (attrs.backstate) {
                $state.go(attrs.backstate, {projectKey: projectKey}, {refresh: true}, {reload: true});
            } else {
                if (stateParams.apiID) {
                    $state.go($state.current.name, {
                        projectKey: projectKey,
                        apiID: stateParams.apiID
                    }, {refresh: true}, {reload: true});
                } else {
                    $state.go($state.current.name, {projectKey: projectKey}, {refresh: true}, {reload: true});
                }
            }
        }


        return {
            getAllKitList: getAllKitList,
            getKitList: getKitList,
            getSearchApiList: getSearchApiList,
            getProjectList: getProjectList,
            createProject: createProject,
            getProjectAPI: getProjectAPI,
            getAllApiList: getAllApiList,
            delProjectAPI: delProjectAPI,
            addProjectAPI: addProjectAPI,
            setProjectKey: setProjectKey,
            getProjectKey: getProjectKey,
            addSubAccount: addSubAccount,
            getProjectCredentialList: getProjectCredentialList,
            addApiKey: addApiKey,
            delClient: delClient,
            modApiKey: modApiKey,
            addSAKey: addSAKey,
            delSAK: delSAK,
            modSubAccountStatus: modSubAccountStatus,
            getAllApiTileList: getAllApiTileList,
            getProjectInfo: getProjectInfo,
            getProjectTotalCount: getProjectTotalCount,
            getAPIDetail: getAPIDetail,
            getApiListByIds: getApiListByIds,
            addOauth: addOauth,
            updateOauth: updateOauth,
            getIsSignAgreement: getIsSignAgreement,
            getOauthAPI: getOauthAPI,
            addOauthAPI: addOauthAPI,
            delOauthAPI: delOauthAPI,
            modOauthAPI: modOauthAPI,
            getProSupOauthAPI: getProSupOauthAPI,
            delProject: delProject,
            getAllCanAddApi: getAllCanAddApi,
            getApiSummaryList: getApiSummaryList,
            getApiIDToNameFilter: getApiIDToNameFilter,
            getApiMetricList: getApiMetricList,
            getApiVersionList: getApiVersionList,
            getMethodSummaryList: getMethodSummaryList,
            getChartOptions: getChartOptions,
            queryProcessContact: queryProcessContact,
            addProcessContact: addProcessContact,
            delProcessContact: delProcessContact,
            modProcessContact: modProcessContact,
            addContactInfoPage: addContactInfoPage,
            modContactInfoPage: modContactInfoPage,
            managerPro: managerPro

        }
    }]);
});


